import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';
import z from 'zod';
import { bidComparisonSheetsQuery } from '@/features/bid-comparison/queries';
import { lastSelectedSheetIdAtom } from '@/features/bid-comparison/store';
import { bidComparisonScope } from '@/features/bid-comparison/utils';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/',
)({
  validateSearch: z.object({
    commentEntityId: z.string().optional(),
    commentId: z.string().optional(),
  }),
  beforeLoad: async ({ context, params }) => {
    const { projectId, workspaceId, procurementId } = params;
    const sheets = await context.queryClient.query({
      ...bidComparisonSheetsQuery(workspaceId, bidComparisonScope(params)),
      staleTime: 'static',
    });
    const lastSelectedSheetId = getDefaultStore().get(lastSelectedSheetIdAtom(params));
    const sheet = sheets.find((s) => s.id === lastSelectedSheetId) ?? sheets[0];
    if (!sheet)
      throw redirect({
        to: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId',
        params: { projectId, workspaceId, procurementId },
        replace: true,
      });
    throw redirect({
      to: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId',
      params: { projectId, workspaceId, procurementId, sheetId: sheet.id },
      search: true,
      replace: true,
    });
  },
});
